module.exports = __webpack_public_path__ + "static/media/11.final.b69148d3.mp4";